import CashboxApproval from "./CashboxApproval";
import { connect } from "react-redux";

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(CashboxApproval);
